import { create } from "zustand";
import { RiskRatingResult } from "../api/transformers/riskRating";
import { RiskRatingAPI } from "../api";
import { first } from "lodash";

type InvestorRiskRatingStore = {
  data: RiskRatingResult[] | null;
  loading: boolean;
  error: unknown;
  getLatestRiskRatingResult: () => RiskRatingResult | undefined;
  fetchData: (personId: string) => void;
}

const useInvestorRiskRatingStore = create<InvestorRiskRatingStore>((set, get) => ({
  data: null,
  loading: true,
  error: null,
  getLatestRiskRatingResult: () => first(get().data),
  // actions
  fetchData: async (personId) => {
    set({ loading: true, error: null, data: null });
    try {
      const result = await RiskRatingAPI.getInvestorRiskRating(personId);
      set({ data: result, loading: false });
    } catch (err) {
      console.error(err);
      set({ error: err, loading: false });
    }
  }
}));

export default useInvestorRiskRatingStore;
